import liveChatService, {
  CustomVariable,
} from 'commons/liveChat/liveChatService';
import { defineStore } from 'pinia';

type State = {
  enabled: boolean;
  open: boolean;
  unreadMessages: number;
};

export const useLiveChatStore = defineStore('liveChat', {
  state: (): State => ({
    enabled: false,
    open: false,
    unreadMessages: 0,
  }),

  actions: {
    setEnabled(enabled: State['enabled']) {
      this.enabled = enabled;
    },
    setUnreadMessages(unreadMessages: State['unreadMessages']) {
      this.unreadMessages = unreadMessages;
    },
    setOpen(open: State['open']) {
      this.open = open;
    },
    async init(customVariables: CustomVariable[]) {
      const isEnabled = liveChatService.isEnabled();

      this.setEnabled(isEnabled);
      if (!isEnabled) {
        return;
      }

      await liveChatService.init(customVariables, (count) =>
        this.setUnreadMessages(count),
      );
      liveChatService.onOpenChange((open) => this.setOpen(open));
    },
    openChat() {
      liveChatService.openChat();
    },
    clearSession() {
      liveChatService.clearSession();
    },
  },
});
